<template>
  <div>
    <v-container class="ml-10">
      <v-row>
        <v-btn depressed large class="white--text" color="grey darken-4" @click="authServiceStart" :disabled="btnDisabled"
          >정품인증서비스 시작하기</v-btn
        >
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Vue from "vue";
import VueJWT from "vuejs-jwt";
import M from "@/libs/mapping.js";

let options = {
  signKey: "shoplus-happy-day",
};
Vue.use(VueJWT, options);

export default {
  data: () => ({
    btnDisabled: false,
  }),
  methods: {
    authServiceStart: function() {
      location.href = `/shoplus_authservice/${this.$store.state.mallId}/serviceIntro`;
    },
    getAppExpire: async function() {
      try {
        let result = await M.api(M.entry("/users/appExpire"));
        let today = new Date();
        let expireAt = new Date(result.expired_at);
        if (expireAt >= today) {
          sessionStorage.shoplusAuthServiceMode = "basic";
        } else {
          sessionStorage.shoplusAuthServiceMode = "any";
          this.alertShow("사용기간이 만료 되었습니다.");
        }
      } catch (e) {
        this.btnDisabled = true;
        this.alertShow("잘못된 접근입니다.");
      }
    },
  },
  created: function() {
    this.getAppExpire();
  },
};
</script>
